module.exports = __webpack_public_path__ + "fonts/e7d6699.otf";